import { TeamAccessDTO } from '../team/team-access.dto';

export class ProductVersionListDTO extends TeamAccessDTO {

    version: string;

    description: string;

}
